(function (global) {

	var scripts = global.BisibiConfig.getScriptAssets();

	var bundles = {};
	bundles[scripts['admin.api.bundle.js']] = [
		'adminTagApi'
	];

	global.require.config({	
		bundles: bundles
	});

})(this);	